var headerData = {
    Apps: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all apps',
                    url: {
                        filterType: 'App'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Microsoft 365',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Microsoft 365',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'office'
                            }
                        },
                        icon: 'Microsoft365',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'Power Platform',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Power Platform',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'power-platform'
                            }
                        },
                        icon: 'PowerPlatform',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'Dynamics 365',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Dynamics 365',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'dynamics-365'
                            }
                        },
                        icon: 'Dynamics365',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'SaaS',
                subTitle: {
                    subTitle: {
                        title: 'Explore SaaS solutions from Microsoft partners',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'saas'
                            }
                        },
                        icon: 'SaaS',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            }
        ]
    },
    Categories: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all categories',
                    url: {
                        filterType: 'App'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: '',
                subTitle: null,
                link: {
                    title: 'See all categories',
                    url: {
                        filterType: 'App'
                    },
                    isButton: false
                },
                filters: [
                    {
                        title: 'AI + machine learning',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'ai-machine-learning'
                        },
                        icon: 'CategoryAIMachineLearning',
                        iconSize: 20
                    },
                    {
                        title: 'Analytics',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'analytics'
                        },
                        icon: 'analyticsview',
                        iconSize: 20
                    },
                    {
                        title: 'Collaboration',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'collaboration'
                        },
                        icon: 'Transition',
                        iconSize: 20
                    },
                    {
                        title: 'Commerce',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'commerce'
                        },
                        icon: 'ShoppingCart',
                        iconSize: 20
                    },
                    {
                        title: 'Compliance + legal ',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'compliance-legals'
                        },
                        icon: 'Compare',
                        iconSize: 20
                    },
                    {
                        title: 'Customer service',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'customer-service'
                        },
                        icon: 'Telemarketer',
                        iconSize: 20
                    },
                    {
                        title: 'Finance',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'finance'
                        },
                        icon: 'Money',
                        iconSize: 20
                    },
                    {
                        title: 'Geolocation',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'geolocation'
                        },
                        icon: 'LocationOutline',
                        iconSize: 20
                    },
                    {
                        title: 'Human resources',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'human-resources'
                        },
                        icon: 'PeopleAdd',
                        iconSize: 20
                    },
                    {
                        title: 'IT management tools',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'it-management-tools'
                        },
                        icon: 'SecurityGroup',
                        iconSize: 20
                    },
                    {
                        title: 'Internet of things',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'internet-of-things'
                        },
                        icon: 'SplitObject',
                        iconSize: 20
                    },
                    {
                        title: 'Marketing',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'marketing'
                        },
                        icon: 'Megaphone',
                        iconSize: 20
                    },
                    {
                        title: 'Operations + Supply Chain',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'operations'
                        },
                        icon: 'WorkFlow',
                        iconSize: 20
                    },
                    {
                        title: 'Productivity',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'productivity'
                        },
                        icon: 'SpeedHigh',
                        iconSize: 20
                    },
                    {
                        title: 'Project management',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'project-management'
                        },
                        icon: 'Assign',
                        iconSize: 20
                    }
                ]
            }
        ]
    },
    Industries: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all Industry Clouds',
                    url: {
                        filterType: 'CloudsIndustry'
                    }
                },
                {
                    isPrimary: false,
                    title: 'See all industries',
                    url: {
                        filterType: 'App'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Industry Clouds',
                subTitle: {
                    subTitle: {
                        title: 'Explore solutions for Microsoft Industry Clouds from Microsoft partners',
                        url: {
                            filterType: 'CloudsIndustry'
                        },
                        icon: '',
                        iconSize: 20
                    },
                    filters: [
                        {
                            description: 'Microsoft Industry Clouds connect robust industry-specific capabilities across Microsoft platforms.Enhance the clouds even more with 3rd-party apps and consulting services.',
                            title: 'Learn more about Industry Clouds',
                            externalUrl: 'https://www.microsoft.com/en-gb/industry?rtc=1',
                            url: {
                                filterType: 'CloudsIndustry'
                            }
                        }
                    ]
                },
                link: {
                    title: 'See all solutions for Industry Clouds',
                    url: {
                        filterType: 'CloudsIndustry'
                    },
                    isButton: false
                },
                filters: [
                    {
                        description: 'Providing capabilites to manage data and to empower finance employees.',
                        title: 'Microsoft Cloud for Financial Services',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'financial-services'
                        },
                        icon: 'Bank',
                        iconSize: 20
                    },
                    {
                        description: 'Trusted and integrated capabilites to deliver better healthcare experiences, better insights and better care.',
                        title: 'Microsoft Cloud for Healthcare',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'healthcare'
                        },
                        icon: 'Health',
                        iconSize: 20
                    },
                    {
                        description: 'Explore cloud capabilities to provide nonprofits with a holistic platform to help accelerate mission outcomes.',
                        title: 'Microsoft Cloud for Nonprofit + IGO',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'nonprofit'
                        },
                        icon: 'Commitments',
                        iconSize: 20
                    },
                    {
                        description: 'Accelerate business growth by providing trusted solutions that easily integrate, connect your customers, people and data.',
                        title: 'Microsoft Cloud for Retail',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'retail-and-consumer-goods'
                        },
                        icon: 'ShoppingCart',
                        iconSize: 20
                    },
                    {
                        description: 'Helps organizations accelerate sustainability progress and business growth with a growing set of ESG capabilities',
                        title: 'Microsoft Cloud for Sustainability',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'sustainability'
                        },
                        icon: 'Cotton',
                        iconSize: 20
                    }
                ]
            },
            {
                title: 'Industries',
                link: {
                    title: 'See all industries',
                    url: {
                        filterType: 'App'
                    },
                    isButton: false
                },
                filters: [
                    {
                        title: 'Defense + intelligence',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'defense-and-intelligence'
                        },
                        icon: 'Shield',
                        iconSize: 20
                    },
                    {
                        title: 'Distribution',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'distribution'
                        },
                        icon: 'DistributeDown',
                        iconSize: 20
                    },
                    {
                        title: 'Education',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'education'
                        },
                        icon: 'Education',
                        iconSize: 20
                    },
                    {
                        title: 'Energy',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'energy'
                        },
                        icon: 'Lightbulb',
                        iconSize: 20
                    },
                    {
                        title: 'Financial services',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'financial-services'
                        },
                        icon: 'Financial',
                        iconSize: 20
                    },
                    {
                        title: 'Government',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'government'
                        },
                        icon: 'Flag',
                        iconSize: 20
                    },
                    {
                        title: 'Healthcare',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'healthcare'
                        },
                        icon: 'Health',
                        iconSize: 20
                    },
                    {
                        title: 'Hospitality + travel',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'hospitality-and-travel'
                        },
                        icon: 'Airplane',
                        iconSize: 20
                    },
                    {
                        title: 'Manufacturing',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'manufacturing-resources'
                        },
                        icon: 'Manufacturing',
                        iconSize: 20
                    },
                    {
                        title: 'Media + communications',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'media-communications'
                        },
                        icon: 'Media',
                        iconSize: 20
                    },
                    {
                        title: 'Non-Profit + IGO',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'nonprofit'
                        },
                        icon: 'Heart',
                        iconSize: 20
                    },
                    {
                        title: 'Professional services',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'professional-services'
                        },
                        icon: 'Suitcase',
                        iconSize: 20
                    },
                    {
                        title: 'Retail',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'retail-and-consumer-goods'
                        },
                        icon: 'BusinessHoursSign',
                        iconSize: 20
                    },
                    {
                        title: 'Sustainability',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'sustainability'
                        },
                        icon: 'Cotton',
                        iconSize: 20
                    }
                ]
            }
        ]
    },
    'Consulting Services': {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all Consulting Services',
                    url: {
                        filterType: 'Service'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Find a consulting service provider for Microsoft products',
                subTitle: {
                    subTitle: {
                        title: 'Find a consulting service provider for Microsoft products',
                        url: {
                            filterType: 'Service'
                        },
                        icon: 'RecruitmentManagement',
                        iconSize: 20
                    },
                    filters: [
                        {
                            description: 'Connect with experts who can help you digitally transform your organization with assestments, briefing, implementation, POC, workshops, and more.'
                        }
                    ]
                },
                filters: [
                    {
                        title: 'Services for Dynamics 365',
                        description: 'Find an expert for products like Sales, Customer Service, Business Central, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'dynamics-365'
                        },
                        icon: 'ServicesDynamics365',
                        iconSize: 60
                    },
                    {
                        title: 'Services for Microsoft 365',
                        description: 'Find an expert for products like Excel, Outlook, Teams, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'office'
                        },
                        icon: 'ServicesMicrosoft365',
                        iconSize: 60
                    },
                    {
                        title: 'Services for Power Platform',
                        description: 'Find an expert for products like Power BI, Power Apps, Power Automate, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'power-platform'
                        },
                        icon: 'ServicesPowerPlatform',
                        iconSize: 60
                    }
                ]
            }
        ]
    },
    Partners: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all partners',
                    url: {
                        filterType: 'Partner'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Partners for Microsoft apps',
                subTitle: {
                    subTitle: {
                        title: 'Partners for Microsoft apps',
                        url: {
                            filterType: 'Partner'
                        },
                        icon: 'UserFollowed',
                        iconSize: 20
                    },
                    filters: [
                        {
                            description: 'Get in touch with trusted Microsoft partners to find up-to-date Microsoft-based services for your business needs.'
                        }
                    ]
                },
                filters: [
                    {
                        title: 'Azure',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Azure'
                        }
                    },
                    {
                        title: 'Office 365',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Office 365'
                        }
                    },
                    {
                        title: 'Surface',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Surface'
                        }
                    },
                    {
                        title: 'Developer tools',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=DeveloperTools'
                        }
                    },
                    {
                        title: 'PowerBI',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=PowerBI'
                        }
                    },
                    {
                        title: 'SurfaceHub',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SurfaceHub'
                        }
                    },
                    {
                        title: 'Dynamics 365',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Dynamics365Business'
                        }
                    },
                    {
                        title: 'Project',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Project'
                        }
                    },
                    {
                        title: 'Teams',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Teams'
                        }
                    },
                    {
                        title: 'Dynamics 365 enterprise',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Dynamics365Enterprise'
                        }
                    },
                    {
                        title: 'SQL',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SQL'
                        }
                    },
                    {
                        title: 'Visio',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Visio'
                        }
                    },
                    {
                        title: 'Enterprise mobility + security',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=EnterpriseMobilityAndSecurity'
                        }
                    },
                    {
                        title: 'SharePoint',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SharePoint'
                        }
                    },
                    {
                        title: 'Windows',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Windows'
                        }
                    },
                    {
                        title: 'Exchange',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Exchange'
                        }
                    },
                    {
                        title: 'Skype for business',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SkypeForBusiness'
                        }
                    },
                    {
                        title: 'Yammer',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Yammer'
                        }
                    },
                    {
                        title: 'Microsoft 365',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Microsoft365'
                        }
                    }
                ]
            },
            {
                title: 'Partner services',
                link: {
                    title: 'See all service types',
                    url: {
                        filterType: 'Partner'
                    },
                    isButton: false
                },
                filters: [
                    {
                        title: 'Consulting',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Consulting'
                        },
                        icon: 'ChatInviteFriend',
                        iconSize: 20
                    },
                    {
                        title: 'IP services (ISV)',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=IP Services (ISV)'
                        },
                        icon: 'Globe',
                        iconSize: 20
                    },
                    {
                        title: 'Managed services (MSP)',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Managed services (MSP)'
                        },
                        icon: 'CRMServices',
                        iconSize: 20
                    },
                    {
                        title: 'Custom solution',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Custom solution'
                        },
                        icon: 'CustomizeToolbar',
                        iconSize: 20
                    },
                    {
                        title: 'Integration',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Integration'
                        },
                        icon: 'PlugConnected',
                        iconSize: 20
                    },
                    {
                        title: 'Project management',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Project management'
                        },
                        icon: 'TimelineProgress',
                        iconSize: 20
                    },
                    {
                        title: 'Deployment or migration',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Deployment or Migration'
                        },
                        icon: 'Deploy',
                        iconSize: 20
                    },
                    {
                        title: 'Learning + certification',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Learning and Certification'
                        },
                        icon: 'D365TalentLearn',
                        iconSize: 20
                    },
                    {
                        title: 'Hardware',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Hardware'
                        },
                        icon: 'PC1',
                        iconSize: 20
                    },
                    {
                        title: 'Licensing',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Licensing'
                        },
                        icon: 'Certificate',
                        iconSize: 20
                    }
                ]
            }
        ]
    }
};
var unifiedHeaderData = {
    Products: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all apps',
                    url: {
                        filterType: 'App'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Azure',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Azure',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'azure'
                            }
                        },
                        icon: 'AzureFill',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'Microsoft 365',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Microsoft 365',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'office'
                            }
                        },
                        icon: 'Microsoft365',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'Power Platform',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Power Platform',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'power-platform'
                            }
                        },
                        icon: 'PowerPlatform',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'Dynamics 365',
                subTitle: {
                    subTitle: {
                        title: 'Explore all apps for Dynamics 365',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'dynamics-365'
                            }
                        },
                        icon: 'Dynamics365',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            },
            {
                title: 'SaaS',
                subTitle: {
                    subTitle: {
                        title: 'Explore SaaS solutions from Microsoft partners',
                        url: {
                            filterType: 'App',
                            query: {
                                product: 'saas'
                            }
                        },
                        icon: 'SaaS',
                        iconSize: 20
                    },
                    filters: []
                },
                filters: []
            }
        ]
    },
    Categories: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all categories',
                    url: {
                        filterType: 'App'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: '',
                subTitle: null,
                link: {
                    title: 'See all categories',
                    url: {
                        filterType: 'App'
                    },
                    isButton: false
                },
                filters: [
                    {
                        title: 'AI + machine learning',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'ai-machine-learning'
                        },
                        icon: 'CategoryAIMachineLearning',
                        iconSize: 20
                    },
                    {
                        title: 'Analytics',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'analytics'
                        },
                        icon: 'analyticsview',
                        iconSize: 20
                    },
                    {
                        title: 'Blockchain',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'blockchain'
                        },
                        icon: 'Blockchain',
                        iconSize: 20
                    },
                    {
                        title: 'Collaboration',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'collaboration'
                        },
                        icon: 'Transition',
                        iconSize: 20
                    },
                    {
                        title: 'Compliance + legal',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'compliance-legals'
                        },
                        icon: 'Compare',
                        iconSize: 20
                    },
                    {
                        title: 'Compute',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'compute'
                        },
                        icon: 'Compute',
                        iconSize: 20
                    },
                    {
                        title: 'Containers',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'containers'
                        },
                        icon: 'Containers',
                        iconSize: 20
                    },
                    {
                        title: 'Customer service',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'customer-service'
                        },
                        icon: 'Telemarketer',
                        iconSize: 20
                    },
                    {
                        title: 'Databases',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'databases'
                        },
                        icon: 'Database',
                        iconSize: 20
                    },
                    {
                        title: 'Developer Tools',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'developer-tools'
                        },
                        icon: 'DeveloperTool',
                        iconSize: 20
                    },
                    {
                        title: 'DevOps',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'devops'
                        },
                        icon: 'Devops',
                        iconSize: 20
                    },
                    {
                        title: 'Finance',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'finance'
                        },
                        icon: 'Money',
                        iconSize: 20
                    },
                    {
                        title: 'Geolocation',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'geolocation'
                        },
                        icon: 'LocationOutline',
                        iconSize: 20
                    },
                    {
                        title: 'Human resources',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'human-resources'
                        },
                        icon: 'PeopleAdd',
                        iconSize: 20
                    },
                    {
                        title: 'Identity',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'identity'
                        },
                        icon: 'Identity',
                        iconSize: 20
                    },
                    {
                        title: 'Integration',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'integration'
                        },
                        icon: 'Integration',
                        iconSize: 20
                    },
                    {
                        title: 'Internet of things',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'internet-of-things'
                        },
                        icon: 'SplitObject',
                        iconSize: 20
                    },
                    {
                        title: 'IT + Management Tools',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'it-management-tools'
                        },
                        icon: 'SecurityGroup',
                        iconSize: 20
                    },
                    {
                        title: 'Marketing',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'marketing'
                        },
                        icon: 'Megaphone',
                        iconSize: 20
                    },
                    {
                        title: 'Media',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'media'
                        },
                        icon: 'Media',
                        iconSize: 20
                    },
                    {
                        title: 'Microsoft Entra ID',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'entra-id'
                        },
                        icon: 'MicrosoftEntraId',
                        iconSize: 20
                    },
                    {
                        title: 'Migration',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'migration'
                        },
                        icon: 'Migration',
                        iconSize: 20
                    },
                    {
                        title: 'Mixed Reality',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'mixed-reality'
                        },
                        icon: 'MixReality',
                        iconSize: 20
                    },
                    {
                        title: 'Monitoring + Diagnostics',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'monitoring'
                        },
                        icon: 'MonitoringAndDiagnostics',
                        iconSize: 20
                    },
                    {
                        title: 'Networking',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'networking'
                        },
                        icon: 'Networking',
                        iconSize: 20
                    },
                    {
                        title: 'Operations + Supply Chain',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'operations'
                        },
                        icon: 'WorkFlow',
                        iconSize: 20
                    },
                    {
                        title: 'Productivity',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'productivity'
                        },
                        icon: 'SpeedHigh',
                        iconSize: 20
                    },
                    {
                        title: 'Project management',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'project-management'
                        },
                        icon: 'Assign',
                        iconSize: 20
                    },
                    {
                        title: 'Sales',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'sales'
                        },
                        icon: 'Shop',
                        iconSize: 20
                    },
                    {
                        title: 'Security',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'security'
                        },
                        icon: 'Security',
                        iconSize: 20
                    },
                    {
                        title: 'Storage',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'storage'
                        },
                        icon: 'Storage',
                        iconSize: 20
                    },
                    {
                        title: 'Web',
                        url: {
                            filterType: 'App',
                            key: 'category',
                            value: 'web'
                        },
                        icon: 'Globe',
                        iconSize: 20
                    }
                ]
            }
        ]
    },
    Industries: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all Industry Clouds',
                    url: {
                        filterType: 'CloudsIndustry'
                    }
                },
                {
                    isPrimary: false,
                    title: 'See all industries',
                    url: {
                        filterType: 'App'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Industry Clouds',
                subTitle: {
                    subTitle: {
                        title: 'Explore solutions for Microsoft Industry Clouds from Microsoft partners',
                        url: {
                            filterType: 'CloudsIndustry'
                        },
                        icon: '',
                        iconSize: 20
                    },
                    filters: [
                        {
                            description: 'Microsoft Industry Clouds connect robust industry-specific capabilities across Microsoft platforms.Enhance the clouds even more with 3rd-party apps and consulting services.',
                            title: 'Learn more about Industry Clouds',
                            externalUrl: 'https://www.microsoft.com/en-gb/industry?rtc=1',
                            url: {
                                filterType: 'CloudsIndustry'
                            }
                        }
                    ]
                },
                link: {
                    title: 'See all solutions for Industry Clouds',
                    url: {
                        filterType: 'CloudsIndustry'
                    },
                    isButton: false
                },
                filters: [
                    {
                        description: 'Providing capabilites to manage data and to empower finance employees.',
                        title: 'Microsoft Cloud for Financial Services',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'financial-services'
                        },
                        icon: 'Bank',
                        iconSize: 20
                    },
                    {
                        description: 'Trusted and integrated capabilites to deliver better healthcare experiences, better insights and better care.',
                        title: 'Microsoft Cloud for Healthcare',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'healthcare'
                        },
                        icon: 'Health',
                        iconSize: 20
                    },
                    {
                        description: 'Explore cloud capabilities to provide nonprofits with a holistic platform to help accelerate mission outcomes.',
                        title: 'Microsoft Cloud for Nonprofit + IGO',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'nonprofit'
                        },
                        icon: 'Commitments',
                        iconSize: 20
                    },
                    {
                        description: 'Accelerate business growth by providing trusted solutions that easily integrate, connect your customers, people and data.',
                        title: 'Microsoft Cloud for Retail',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'retail-and-consumer-goods'
                        },
                        icon: 'ShoppingCart',
                        iconSize: 20
                    },
                    {
                        description: 'Helps organizations accelerate sustainability progress and business growth with a growing set of ESG capabilities',
                        title: 'Microsoft Cloud for Sustainability',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'sustainability'
                        },
                        icon: 'Cotton',
                        iconSize: 20
                    },
                    {
                        description: 'Accelerate innovation, optimize operations, empower workers, and enhance customer experiences.',
                        title: 'Microsoft Cloud for Manufacturing',
                        url: {
                            filterType: 'CloudsIndustry',
                            key: 'industry',
                            value: 'manufacturing'
                        },
                        icon: 'Manufacturing',
                        iconSize: 20
                    }
                ]
            },
            {
                title: 'Industries',
                link: {
                    title: 'See all industries',
                    url: {
                        filterType: 'App'
                    },
                    isButton: false
                },
                filters: [
                    {
                        title: 'Defense + intelligence',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'defense-and-intelligence'
                        },
                        icon: 'Shield',
                        iconSize: 20
                    },
                    {
                        title: 'Distribution',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'distribution'
                        },
                        icon: 'DistributeDown',
                        iconSize: 20
                    },
                    {
                        title: 'Education',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'education'
                        },
                        icon: 'Education',
                        iconSize: 20
                    },
                    {
                        title: 'Energy',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'energy'
                        },
                        icon: 'Lightbulb',
                        iconSize: 20
                    },
                    {
                        title: 'Financial services',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'financial-services'
                        },
                        icon: 'Financial',
                        iconSize: 20
                    },
                    {
                        title: 'Government',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'government'
                        },
                        icon: 'Flag',
                        iconSize: 20
                    },
                    {
                        title: 'Healthcare',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'healthcare'
                        },
                        icon: 'Health',
                        iconSize: 20
                    },
                    {
                        title: 'Hospitality + travel',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'hospitality-and-travel'
                        },
                        icon: 'Airplane',
                        iconSize: 20
                    },
                    {
                        title: 'Manufacturing',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'manufacturing-resources'
                        },
                        icon: 'Manufacturing',
                        iconSize: 20
                    },
                    {
                        title: 'Media + communications',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'media-communications'
                        },
                        icon: 'Media',
                        iconSize: 20
                    },
                    {
                        title: 'Non-Profit + IGO',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'nonprofit'
                        },
                        icon: 'Heart',
                        iconSize: 20
                    },
                    {
                        title: 'Professional services',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'professional-services'
                        },
                        icon: 'Suitcase',
                        iconSize: 20
                    },
                    {
                        title: 'Retail',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'retail-and-consumer-goods'
                        },
                        icon: 'BusinessHoursSign',
                        iconSize: 20
                    },
                    {
                        title: 'Sustainability',
                        url: {
                            filterType: 'App',
                            key: 'industry',
                            value: 'sustainability'
                        },
                        icon: 'Cotton',
                        iconSize: 20
                    }
                ]
            }
        ]
    },
    'Professional Services': {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all Consulting Services',
                    url: {
                        filterType: 'Service'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Find a consulting service provider for Microsoft products',
                subTitle: {
                    subTitle: {
                        title: 'Find a consulting service provider for Microsoft products',
                        url: {
                            filterType: 'Service'
                        },
                        icon: 'RecruitmentManagement',
                        iconSize: 20
                    },
                    filters: [
                        {
                            description: 'Connect with experts who can help you digitally transform your organization with assestments, briefing, implementation, POC, workshops, and more.'
                        }
                    ]
                },
                filters: [
                    {
                        title: 'Services for Azure',
                        description: 'Find an expert for products like Virtual Machine images, Azure apps, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'azure'
                        },
                        icon: 'ServicesAzure',
                        iconSize: 60
                    },
                    {
                        title: 'Services for Microsoft 365',
                        description: 'Find an expert for products like Excel, Outlook, Teams, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'office'
                        },
                        icon: 'ServicesMicrosoft365',
                        iconSize: 60
                    },
                    {
                        title: 'Services for Power Platform',
                        description: 'Find an expert for products like Power BI, Power Apps, Power Automate, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'power-platform'
                        },
                        icon: 'ServicesPowerPlatform',
                        iconSize: 60
                    },
                    {
                        title: 'Services for Dynamics 365',
                        description: 'Find an expert for products like Sales, Customer Service, Business Central, and more.',
                        url: {
                            filterType: 'Service',
                            key: 'product',
                            value: 'dynamics-365'
                        },
                        icon: 'ServicesDynamics365',
                        iconSize: 60
                    }
                ]
            }
        ]
    },
    Partners: {
        header: {
            buttons: [
                {
                    isPrimary: true,
                    title: 'See all partners',
                    url: {
                        filterType: 'Partner'
                    }
                }
            ]
        },
        filtersSection: [
            {
                title: 'Partners for Microsoft apps',
                subTitle: {
                    subTitle: {
                        title: 'Partners for Microsoft apps',
                        url: {
                            filterType: 'Partner'
                        },
                        icon: 'UserFollowed',
                        iconSize: 20
                    },
                    filters: [
                        {
                            description: 'Get in touch with trusted Microsoft partners to find up-to-date Microsoft-based services for your business needs.'
                        }
                    ]
                },
                filters: [
                    {
                        title: 'Azure',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Azure'
                        }
                    },
                    {
                        title: 'Office 365',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Office 365'
                        }
                    },
                    {
                        title: 'Surface',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Surface'
                        }
                    },
                    {
                        title: 'Developer tools',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=DeveloperTools'
                        }
                    },
                    {
                        title: 'PowerBI',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=PowerBI'
                        }
                    },
                    {
                        title: 'SurfaceHub',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SurfaceHub'
                        }
                    },
                    {
                        title: 'Dynamics 365',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Dynamics365Business'
                        }
                    },
                    {
                        title: 'Project',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Project'
                        }
                    },
                    {
                        title: 'Teams',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Teams'
                        }
                    },
                    {
                        title: 'Dynamics 365 enterprise',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Dynamics365Enterprise'
                        }
                    },
                    {
                        title: 'SQL',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SQL'
                        }
                    },
                    {
                        title: 'Visio',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Visio'
                        }
                    },
                    {
                        title: 'Enterprise mobility + security',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=EnterpriseMobilityAndSecurity'
                        }
                    },
                    {
                        title: 'SharePoint',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SharePoint'
                        }
                    },
                    {
                        title: 'Windows',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Windows'
                        }
                    },
                    {
                        title: 'Exchange',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Exchange'
                        }
                    },
                    {
                        title: 'Skype for business',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=SkypeForBusiness'
                        }
                    },
                    {
                        title: 'Yammer',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Yammer'
                        }
                    },
                    {
                        title: 'Microsoft 365',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'products=Microsoft365'
                        }
                    }
                ]
            },
            {
                title: 'Partner services',
                link: {
                    title: 'See all service types',
                    url: {
                        filterType: 'Partner'
                    },
                    isButton: false
                },
                filters: [
                    {
                        title: 'Consulting',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Consulting'
                        },
                        icon: 'ChatInviteFriend',
                        iconSize: 20
                    },
                    {
                        title: 'IP services (ISV)',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=IP Services (ISV)'
                        },
                        icon: 'Globe',
                        iconSize: 20
                    },
                    {
                        title: 'Managed services (MSP)',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Managed services (MSP)'
                        },
                        icon: 'CRMServices',
                        iconSize: 20
                    },
                    {
                        title: 'Custom solution',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Custom solution'
                        },
                        icon: 'CustomizeToolbar',
                        iconSize: 20
                    },
                    {
                        title: 'Integration',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Integration'
                        },
                        icon: 'PlugConnected',
                        iconSize: 20
                    },
                    {
                        title: 'Project management',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Project management'
                        },
                        icon: 'TimelineProgress',
                        iconSize: 20
                    },
                    {
                        title: 'Deployment or migration',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Deployment or Migration'
                        },
                        icon: 'Deploy',
                        iconSize: 20
                    },
                    {
                        title: 'Learning + certification',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Learning and Certification'
                        },
                        icon: 'D365TalentLearn',
                        iconSize: 20
                    },
                    {
                        title: 'Hardware',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Hardware'
                        },
                        icon: 'PC1',
                        iconSize: 20
                    },
                    {
                        title: 'Licensing',
                        url: {
                            filterType: 'Partner',
                            key: 'filter',
                            value: 'services=Licensing'
                        },
                        icon: 'Certificate',
                        iconSize: 20
                    }
                ]
            }
        ]
    }
};

export { headerData, unifiedHeaderData };
